// Common query params to preserve when resetting filters or view state
export const PRESERVED_QUERY_PARAMS = ['page', 'pageSize', 'limit', 'offset', 'search', 'sorting'];
